module.exports = __webpack_public_path__ + "static/santa-claus-15615de42289a1308fa2bb3694a89d5e.svg";